export default {
      id: "chevron-down-usage",
      viewBox: "0 0 383 246",
      url: "../../assets/" + "sprite.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }